import React, { ReactNode, useEffect } from 'react';
import { DemoOrgProvider } from 'src/contexts/DemoOrgContext';
import { usePostHog } from 'posthog-js/react';

interface DemoWrapperProps {
  children: ReactNode;
}

const DemoWrapper: React.FC<DemoWrapperProps> = ({ children }) => {
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.register({ is_demo: true });

    return () => {
      posthog?.unregister('is_demo');
    };
  }, [posthog]);

  return (
    <DemoOrgProvider>
      {children}
    </DemoOrgProvider>
  );
};

export default DemoWrapper;